import styled from 'styled-components';

export const MainContainer = styled.main`
  color: #333333;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  max-width: 670px;
  margin-bottom: 56px;
  flex: 1;
  @media (max-width: 650px) {
    justify-content: center;
    width: 90%;
  }
`;
